(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('CreateSOOPController', CreateSOOPController);

    CreateSOOPController.$inject = ['$rootScope', '$sce', '$controller', '$uibModalInstance', 'entity', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes'];

    function CreateSOOPController($rootScope, $sce, $controller, $uibModalInstance, entity, parameters, SoopkitchenUtils, Planning, PlanTypes) {
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": "Create SOOP/Floating Timeline", $sce: $sce, $uibModalInstance: $uibModalInstance}));

        var vm = this;

        /**** Properties ****/
        vm.plan = entity;
        vm.planType = parameters.planType;
        vm.obsDefLabel = parameters.obsDefLabel;
        vm.observations = parameters.occurrences;
        vm.planLabel = parameters.planLabel;
        vm.soops = {
            "ALL": ['']
        };
        vm.soopTypes = [];
        vm.selectedSoop = "";
        vm.selectedType = "ALL";
        //Overriding Properties from SoopkitchenDialogController:
        vm.saveText = "Save";
        vm.saveSoopInPlan = true;
        vm.saveSoopTemplate = false;
        vm.savePlanTemplate = false;
        vm.soopDurationString = null;
        vm.soopPlanLabel = null;
        vm.instruments = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI', 'EPD', 'MAG', 'RPW', 'SWA'];
        vm.selectedSoopLeadInstrument = null;
        vm.templateDurationString = null;
        vm.templatePlanLabel = null;
        
        var earliestDate = Date.parse(vm.observations[0].startDate);
        var latestDate = Date.parse(vm.observations[0].endDate);
        for (var i = 1; i < vm.observations.length; i++) {
            var start = Date.parse(vm.observations[i].startDate);
            var end = Date.parse(vm.observations[i].endDate);
            if (start < earliestDate) {
                earliestDate = start;
            }
            if (end > latestDate) {
                latestDate = end;
            }
        } 
        vm.duration = (latestDate - earliestDate) / 1000;
        vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
                
        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = save;

        //load combobox
        Planning.getSoopTypes({}, successLoadingSoopTypes, failureLoadingSoopTypes);

        function successLoadingSoopTypes(data) {
            if (data) {
                data = angular.fromJson(data);
                vm.soopTypes = [];
                vm.soopTypes.push("");
                data.forEach(function (item) {
                    vm.soopTypes.push(item);
                });
                vm.selectedSoopType = vm.soopTypes[0];
            }
            vm.waiting = false;

        }

        function failureLoadingSoopTypes(response) {
            SoopkitchenUtils.prettyError(response);
            vm.waiting = false;
        }

        function successCallback() {
            if (vm.callbackMsg.length > 0) {
                SoopkitchenUtils.invokeSweetAlert("Nice!", vm.callbackMsg, "success", function () {
                    SoopkitchenUtils.updatePlanFromDialog(vm.data);
                    $uibModalInstance.dismiss('cancel');
                });
            }
        }

        function failureCallback(response) {
            SoopkitchenUtils.processResponse(response, vm.callbackMsg, vm.callbackMsgError, function () {
                location.reload();
                $uibModalInstance.dismiss('cancel');
            });
        }
        
        function processErrorResponseCallback(response) {
            return function () {
                SoopkitchenUtils.processResponse(response, '', vm.callbackMsgError, function () {
                    location.reload();
                    $uibModalInstance.dismiss('cancel');
                });
            }
        }

        function getCreateSoopPlanFunction(success) {
            if (vm.saveSoopTemplate) {
                return function () {
                    Planning.create(
                        {
                            planType: PlanTypes['soop'],
                            obsDefLabel: vm.obsDefLabel,
                            duration: SoopkitchenUtils.timeToSeconds(vm.soopDurationString),
                            planLabel: vm.soopPlanLabel,
                            leadInstrument: vm.selectedSoopLeadInstrument,
                            soopType: vm.selectedSoopType,
                        },
                        vm.observations,
                        function () {
                            vm.callbackMsg += 'Successfully Saved SOOP template\n';
                            success();
                        },
                        function (response) {
                            vm.callbackMsgError += 'Failed to save the SOOP template';
                            failureCallback(response);
                        }
                    );
                }
            } else {
                return function() {
                    success();
                }
            }
        }

        function getCreateTemplatePlanFunction(success) {
            if (vm.savePlanTemplate) {
                return function () {
                    Planning.create(
                        {
                            planType: PlanTypes['template'],
                            obsDefLabel: vm.obsDefLabel,
                            duration: SoopkitchenUtils.timeToSeconds(vm.templateDurationString),
                            planLabel: vm.templatePlanLabel
                        },
                        vm.observations,
                        function () {
                            vm.callbackMsg += 'Successfully saved Floating Timeline\n';
                            success();
                        },
                        function (response) {
                            vm.callbackMsgError += 'Failed to save the Floating Timeline';
                            failureCallback(response);
                        }
                    );
                }
            } else {
                return function() {
                    success();
                }
            }
        }

        function getSaveSoopInPlanFunction(success) {
            if (vm.saveSoopInPlan) {
                return function () {
                    Planning.createSoop(
                        {
                            planLabel: vm.planLabel,
                            soopType: vm.selectedSoopType,
                            planType: vm.planType
                        },
                        vm.observations,
                        function (data) {
                            vm.data = data;
                            vm.callbackMsg += 'Successfully created SOOP instance in Plan\n';
                            success();
                        },
                        function (response) {
                            vm.callbackMsgError += 'Failed to create the SOOP instance in the Plan';
                            failureCallback(response);
                        }
                    );
                } 
            } else {
                return function() {
                    success();
                }
            }
        }

        function save() {
            vm.data = null;
            vm.callbackMsg = '';
            vm.callbackMsgError = '';
            vm.failedToCreateSoop = '';
            vm.waiting = true;
            getSaveSoopInPlanFunction(getCreateSoopPlanFunction(getCreateTemplatePlanFunction(successCallback)))();
        }
    }
})();
